import { render } from "./BackendArea.vue?vue&type=template&id=8d1e1b5c"
import script from "./BackendArea.vue?vue&type=script&lang=js"
export * from "./BackendArea.vue?vue&type=script&lang=js"

import exportComponent from "/home/kreativ-mobil.com/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__